import NotificationPreview from '../../NotificationPreview';
import { notificationActions } from '../../../utils/notificationActions';
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Box,
  FormControlLabel,
  Switch,
  TextField,
  MenuItem,
  Button,
  DialogActions,
  DialogContent,
  Stack,
  Typography,
} from "@mui/material";
import Textfield from "../../../common/Textfield";
import { getAgencyDetailFunc } from "../../../actions/Agency";
import { segmentTrack } from "../../../utils/helpers/tracking_utils";

const ComposeMessageStep = ({
  activeStep,
  steps,
  handleNext,
  formValues,
  setFormValues,
}) => {
  const [errorMsg, setErrorMsg] = useState("");

  const dispatch = useDispatch();
  
  const agentProfile = useSelector((state) => state.agentProfile);
  const { agentUser } = agentProfile;

  const getAgencyDetail = useSelector((state) => state.getAgencyDetail);
  const {
    agencyDetail,
  } = getAgencyDetail;

  useEffect(() => {
    dispatch(getAgencyDetailFunc());
  }, [dispatch]);

  // SUBMIT  FORM
  const submitMessageHandler = async (e) => {
    e.preventDefault();
   

    if (!formValues.messageTitle.trim()) {
      setErrorMsg("Please enter message title");
      return;
    }

    if (!formValues.messageDescription.trim()) {
      setErrorMsg("Please enter message description");
      return;
    }

    if (formValues.ctaDestination && (!formValues.ctaLabel?.trim() || formValues.ctaLabel.trim().length > 40)) {
      setErrorMsg("Enter button text (1–40 characters)");
      return;
    }
    setErrorMsg("");

    // if (!formValues.messageDescription.trim()) {
    //   setErrorMsg("Please enter message description");
    //   return;
    // }

    handleNext();

    if (agentUser?.agent && agencyDetail?.agency) {
      segmentTrack({ event: "pn_message_added", agent: agentUser?.agent, agency: agencyDetail?.agency })
    }
  };

  return (
    <>
      <DialogContent sx={{ padding: "32px !important", minHeight: 0, height: 462 }}>
        <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: 'minmax(0, 1.15fr) minmax(0, 1fr)' }, gap: 4, alignItems: 'start' }}>
        <Stack gap="24px">
          <Typography variant="subtitle1" fontSize="16px" fontWeight="400">
            Keeping your push message short will help you to engage more
            clients.
          </Typography>
          <Textfield
            label="Push Message Title"
            variant="outlined"
            value={formValues.messageTitle}
            onChange={(e) =>
              setFormValues({ ...formValues, messageTitle: e.target.value.slice(0, 100) })
            }
            errorContent={!formValues.messageTitle.trim() && errorMsg}
            helperText={!formValues.messageTitle.trim() && errorMsg}
          />
          <Textfield
            label="Push Message"
            name="messageDescription"
            multiline
            maxRows={3}
            variant="outlined"
            value={formValues.messageDescription}
            errorContent={!formValues.messageDescription.trim() && errorMsg}
            helperText={!formValues.messageDescription.trim() && errorMsg}
            onChange={(e) =>
              setFormValues({
                ...formValues,
                messageDescription: e.target.value,
              })
            }
          />
          <Box>
            <FormControlLabel control={<Switch checked={Boolean(formValues.ctaDestination)} onChange={e => setFormValues({...formValues, ctaDestination: e.target.checked ? 'referral' : ''})} />} label="Add a call-to-action button" />
            {formValues.ctaDestination && <Stack spacing={2} sx={{ mt: 2 }}>
              <TextField fullWidth label="Button text" placeholder="e.g. Refer a Friend" value={formValues.ctaLabel || ''}
                inputProps={{ maxLength: 40 }}
                onChange={e => setFormValues({...formValues, ctaLabel: e.target.value})}
                error={Boolean(errorMsg && !formValues.ctaLabel?.trim())}
                helperText={errorMsg && !formValues.ctaLabel?.trim() ? 'Enter button text (1–40 characters)' : `${(formValues.ctaLabel || '').length}/40 characters`} />
              <TextField select fullWidth label="Screen to open" value={formValues.ctaDestination} onChange={e => setFormValues({...formValues, ctaDestination: e.target.value})} helperText={notificationActions.find(action => action.value === formValues.ctaDestination)?.detail}>
                {notificationActions.map(action => <MenuItem key={action.value} value={action.value}>{action.label}</MenuItem>)}
              </TextField>
            </Stack>}
          </Box>
        </Stack>
        <NotificationPreview title={formValues.messageTitle} body={formValues.messageDescription} destination={formValues.ctaDestination} buttonText={formValues.ctaLabel} />
        </Box>
      </DialogContent>

      <DialogActions
        sx={{
          padding: "16px 32px",
          boxShadow: "0px -2px 16px 0px rgba(0, 0, 0, 0.08)",
        }}
      >
        <Button variant="contained" onClick={submitMessageHandler}>
          {activeStep === steps.length - 1 ? "Finish" : "Continue"}
        </Button>
      </DialogActions>
    </>
  );
};

export default ComposeMessageStep;
